<template>
<div class="">
<user-top></user-top>
<div class="millia pb50">
<div class="ht tc mt50">基本个人信息</div>
<div class="user">
<div class="btGroup" id="editBt01">
<span class="editBt" @click="getAllData">编辑</span>
</div>
<ul class="infoList">
<li><label>姓名：</label>{{allData.realname}}</li>
<li><label>照片：</label><img :src="imgUrl" class="userImg"></li>
<li><label>性别：</label>{{allData.sex}}</li>
<li><label>身份证号码：</label>{{allData.id_card}}</li>
<!--<li><label>民族：</label>{{allData.nation}}</li>-->
<li><label>政治面貌：</label>{{allData.political_status}}</li>
<!--<li><label>身份类型：</label>{{allData.user_type}}</li>-->
<li><label>学历：</label>{{allData.education}}</li>
<li><label>学位：</label>{{allData.degree}}</li>
<li><label>专业：</label>{{allData.major}}</li>
<li><label>毕业学校：</label>{{allData.graduated_school}}</li>
<li><label>毕业时间：</label>{{allData.graduated_time}}</li>
<li><label>工作时间：</label>{{allData.work_time}}</li>
<!--<li><label>工作单位：</label>{{allData.employer}}</li>-->
<li><label>户籍所在地：</label>{{allData.household}}</li>
<!--<li><label>其他说明：</label>{{allData.other}}</li>-->
</ul>
</div>
<!-- <div class="hideInfo" id="allInfo">
<div class="ht tc pt20">编辑个人基本信息</div>
<div id="close01" class="close">X</div>
<basic-info></basic-info>
</div> -->


<div class="ht tc mt50">教育经历信息</div>
<ul class="expList">
<li v-for="(eduLists,id) of eduList" :key="id" :id="eduLists.id">
<p><label>学校名称：</label>{{eduLists.school_name}}</p>
<p><label>所获学历：</label>{{eduLists.education}}</p>
<p><label>专业：</label>{{eduLists.major}}</p>
<p><label>开始时间：</label>{{eduLists.start_time}}</p>
<p><label>结束时间：</label>{{eduLists.end_time}}</p>
<div class="btGroup">
<!-- <span class="editBt" @click="EduEdit">编辑</span> -->
<span class="deleteBt" @click="EduDelet(eduLists.id)">删除</span>
</div>
</li>
</ul>

<div class="ht tc mt50">工作经历经历信息</div>
<ul class="expList">
<li v-for="(jobLists,id) of jobList" :key="id" :id="jobLists.id">
<p><label>公司名称：</label>{{jobLists.company_name}}</p>
<p><label>岗位：</label>{{jobLists.position}}</p>
<p><label>开始时间：</label>{{jobLists.start_time}}</p>
<p><label>离职时间：</label>{{jobLists.end_time}}</p>
<p><label>岗位说明：</label>{{jobLists.work_exp}}</p>
<div class="btGroup">
<!-- <span class="editBt">编辑</span> -->
<span class="deleteBt" @click="JobDelete(jobLists.id)">删除</span>
</div>
</li>
</ul>


<div class="ht tc mt50">家庭成员历信息</div>
<ul class="expList">
<li v-for="(familyLists,id) of familyList" :key="id" :id="familyLists.id">
<p><label>姓名：</label>{{familyLists.realname}}</p>
<p><label>手机号码：</label>{{familyLists.phone}}</p>
<p><label>成员关系：</label>{{familyLists.relation}}</p>
<p><label>工作单位：</label>{{familyLists.work_add}}</p>
<div class="btGroup">
<!-- <span class="editBt">编辑</span> -->
<span class="deleteBt" @click="FamilyDelete(familyLists.id)">删除</span>
</div>
</li>
</ul>


</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop';
import BasicInfo from '@/components/BasicInfo';
import EduExp from '@/components/EduExp';
import JobExp from '@/components/JobExp';
import FamilyGroup from '@/components/FamilyGroup';
export default {
    name: "MyInfo",
    inject: ["reload"],
    components: {
        UserTop,
        BasicInfo,
        EduExp,
        JobExp,
        FamilyGroup
    },
    data () {
        return {
            allData: {},
            imgUrl:{},
            eduList:{},
            jobList:{},
            familyList:{},
        }
    },
    mounted () {
        this.getAllData();
        var editBt01 = document.getElementById("editBt01");
        var allInfo = document.getElementById("allInfo");
        var close01 = document.getElementById("close01");
        editBt01.onclick = function(){
            allInfo.style.display = "block";
        }
        close01.onclick = function(){
            allInfo.style.display = "none";
        }
    },
    methods: {
        getAllData() {
            let url = "api/user/getUserInfo";
            let params = {}
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    this.allData = response.data.data;
                    this.imgUrl = response.data.data.img_url;
                    this.eduList = response.data.data.edu_exp;
                    this.jobList = response.data.data.work_exp;
                    this.familyList = response.data.data.family;
                    //console.log(this.eduList);
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98){
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        EduDelet(id){
            let url = "api/user/delEduExp";
            let params = {
                id:id
            }
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    layer.alert("教育经历删除成功!");
                    this.reload();
                    //console.log(this.allData);
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98) {
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
            //this.eduList.splice(id,1);
            //alert("删除成功!");
        },
        JobDelete(id){
            let url = "api/user/delWorkExp";
            let params = {
                id:id
            }
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    layer.alert("工作经历删除成功!");
                    this.reload();
                    //console.log(this.allData);
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98){
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        },
        FamilyDelete(id){
            let url = "api/user/delFamily";
            let params = {
                id:id
            }
            this.$ajax.get(url,params).then(function (response) {
                if (response.data.status==1) {
                    layer.alert("家庭关系删除成功!");
                    this.reload();
                    //console.log(this.allData);
                }else{
                    console.log(response.data.info);
                }
                if (response.data.status==-98){
                    //alert(response.data.info);
                    this.$router.push('/');
                }
            }.bind(this)).catch(function (err) {
                console.log("连接失败");
            }.bind(this));
        }
    }

}
</script>
<style scoped>
.user{position:relative;}
.btGroup{position:absolute;top:0;right:0;}
.btGroup span{display:block;margin-top:1rem;}
.editBt,.deleteBt{background:#D0EEFF;border:.1rem solid #99D3F5;border-radius:.5rem;padding:0 1rem;overflow:hidden;color:#1E88C7;font-size:1.4rem;line-height:2.2rem;}
.deleteBt{background:#f0f0f0;color:#333;border:.1rem solid #d8d8d8;}
.infoList li{padding-bottom:1rem;font-size:1.4rem;color:#666;}
.infoList li label,.expList li p label{display:inline-block;padding-right:1rem;font-weight:bold;font-size:1.5rem;color:#333;}
.expList li{border-top:1px dotted #d0d0d0;padding:1.5rem 0;font-size:1.4rem;color:#666;position:relative;}
.expList li p{padding-bottom:1rem;}
.expList li .editBt{top:1rem;}
.userImg{width:10rem;height:auto;border:1px solid #d0d0d0;}
.hideInfo{padding:1rem 0 0 0;}
.hideInfo li{margin-bottom:1rem;position:relative;}
.hideInfo{display:none;}
#allInfo{position:fixed;left:0;top:0;width:100%;height:100%;z-index:9999;overflow-y:auto;padding:2%;box-sizing:border-box;background:#fff;}
.close{position:absolute;right:0;top:0;background:#000;color:#fff;width:4rem;height:4rem;text-align:center;line-height:4rem;border-radius:0 0 0 3rem;}
</style>